import React, { useState, useEffect, useRef } from 'react'
import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import { Form, Button } from 'react-bootstrap'
import LoadingSpinner from '../../components/LoadingSpinner'
import { useHistory } from 'react-router-dom'
import styles from './Members.module.scss'
import { Api, Endpoint } from '../../api'
import Helpers from '../../helpers/general'
import registerFormStyle from '../Register/Register.module.scss'
import PhoneInput from 'react-phone-input-2'

const { passwordRegex, passwordMessage } = Helpers.getPasswordRegex()

function VerifyAccountMember() {
	const [loading, setLoading] = useState(true)
	const [submitLoading, setSubmitLoading] = useState(false)
	const [error, setError] = useState(false)
	const [memberData, setMemberData] = useState(null)
	const [phoneNumber, setPhoneNumber] = useState('+1')
	const history = useHistory()

	const { register, handleSubmit, errors, setValue, watch } = useForm()

	const password = useRef({})
	password.current = watch('password', '')

	useEffect(() => {
		register({ name: 'phoneNumber', value: phoneNumber })
		//eslint-disable-next-line
	}, [])

	useEffect(() => {
		setValue('phoneNumber', phoneNumber)
		//eslint-disable-next-line
	}, [phoneNumber])

	const getToken = () => {
		return new URLSearchParams(window.location.search).get('token')
	}

	const verifyAccountToken = async () => {
		const response = await Api.call(Endpoint.verifyMemberToken, { params: [getToken()] })
		if (response?.confirmation === 'Fail') {
			setLoading(false)
			setError('Your account has been already verified or this link is not valid.')
			return
		}
		setMemberData(response?.message)
		setLoading(false)
		setError(null)
	}

	const submit = async (data) => {
		setSubmitLoading(true)
		const response = await Api.call(Endpoint.verifyMemberAccount, { data, params: [getToken()] })
		if (response?.confirmation === 'Success') {
			setSubmitLoading(false)
			toast('Account completed successfully.')
			history.push('/login')
			return
		}
		setSubmitLoading(false)
		toast(response?.message)
	}

	useEffect(() => {
		verifyAccountToken()
		//eslint-disable-next-line
	}, [])

	return (
		<>
			<div className={styles.bodyWrapper}>
				{loading ? (
					<>
						<LoadingSpinner />
						<p className={styles.loadingText}>Please wait...</p>
					</>
				) : error ? (
					<>
						<i className="fas fa-exclamation-circle fa-7x"></i>
						<h3 className={styles.errorText}>{error}</h3>
					</>
				) : (
					<>
						<div className={registerFormStyle.loginPageWrapper}>
							<div className={registerFormStyle.pageContainer}>
								<Form.Group>
									{memberData?.username && (
										<h3>
											{' '}
											Hi <strong>{memberData?.username}!</strong>{' '}
										</h3>
									)}
									<p className="form-desc">Please complete your account.</p>
								</Form.Group>
								<Form onSubmit={handleSubmit(submit)}>
									<Form.Group>
										<i className="fal fa-user"></i>
										<Form.Control
											ref={register}
											type="text"
											name="firstName"
											placeholder="First Name"
										/>
									</Form.Group>
									<Form.Group>
										<i className="fal fa-user"></i>
										<Form.Control
											ref={register}
											type="text"
											name="lastName"
											placeholder="Last Name"
										/>
									</Form.Group>
									<Form.Group>
										<i className="fal fa-envelope"></i>
										<Form.Control
											type="text"
											name="email"
											disabled={true}
											defaultValue={memberData?.email}
											placeholder="Email"
										/>
									</Form.Group>
									<Form.Group>
										<i className="fal fa-user"></i>
										<Form.Control
											defaultValue={memberData?.username ? memberData?.username : ''}
											ref={register({ required: 'Username cannot be empty' })}
											type="text"
											name="username"
											placeholder="Username"
										/>
										{errors?.username?.message && (
											<small className={registerFormStyle.registerErrorText}>
												{errors?.username?.message}
											</small>
										)}
									</Form.Group>
									<Form.Group>
										<i className="fal fa-user"></i>
										<PhoneInput
											inputStyle={{ width: '100%' }}
											country={'us'}
											value={phoneNumber}
											onChange={(phone) => setPhoneNumber(phone)}
										/>
									</Form.Group>
									<Form.Group>
										<i className="fal fa-lock"></i>
										<Form.Control
											ref={register({
												required: 'Password cannot be empty',
												pattern: { value: passwordRegex, message: passwordMessage },
											})}
											type="password"
											name="password"
											placeholder="Password"
										/>
										{errors?.password?.message && (
											<small className={registerFormStyle.registerErrorText}>
												{errors?.password?.message}
											</small>
										)}
									</Form.Group>
									<Form.Group>
										<i className="fal fa-lock"></i>
										<Form.Control
											ref={register({
												required: 'Confirm password cannot be empty',
												validate: (value) =>
													value === password.current ||
													'The password confirmation does not match.',
											})}
											type="password"
											name="confirm_password"
											placeholder="Confirm Password"
										/>
										{errors?.confirm_password?.message && (
											<small className={registerFormStyle.registerErrorText}>
												{errors?.confirm_password?.message}
											</small>
										)}
									</Form.Group>
									<Button
										type="submit"
										disabled={submitLoading || Object.keys(errors).length > 0 ? true : false}
										style={{ width: '100%' }}
										onClick={handleSubmit(submit)}
									>
										{submitLoading ? <LoadingSpinner size="sm" /> : 'Submit'}
									</Button>
								</Form>
							</div>
						</div>
					</>
				)}
			</div>
		</>
	)
}

export default VerifyAccountMember
